const monthlyMeetupsData = [
    {
        id: "march",
        month: "March 2026 Meetup",
        title: "Move Today, Live Better Longer",
        videoUrl: "https://vimeo.com/1187721542",
        intro: "In this Momentum Meetup, Val talks about one of the most important reasons to stay active: not just living longer, but living better for longer.",
        focus: "The talk focuses on healthspan: how long you stay healthy, strong, mobile, and independent.",
        sections: [
            {
                title: "Key Insights",
                items: [
                    {
                        title: "Healthspan is about independence, not just longevity.",
                        body: "The goal is to keep doing the things that matter: walking, travelling, climbing stairs, carrying groceries, playing with grandchildren, and staying active later in life.",
                    },
                    {
                        title: "What you do today shapes what you can do after 80.",
                        body: "The strength, heart health, balance, and mobility you build now become a gift to your future self.",
                    },
                    {
                        title: "Aging is normal, but the pace is not completely out of your control.",
                        body: "After 45, we naturally lose muscle, bone strength, balance, and cardiovascular efficiency. Regular exercise can help slow many of those changes.",
                    },
                    {
                        title: "Exercise protects more than your fitness.",
                        body: "Movement supports your heart, brain, blood sugar, inflammation, immune function, metabolism, and long-term mobility.",
                    },
                    {
                        title: "Strength, balance, and mobility matter as much as cardio.",
                        body: "Walking is powerful, but strength training and mobility work help protect your joints, prevent falls, and support independence as you age.",
                    },
                ],
            },
            {
                title: "Tools & Programs Mentioned",
                items: [
                    {
                        title: "Calorie Deficit Calculator & Mini-Course",
                        body: "Estimate maintenance calories and choose a sensible daily deficit target.",
                        path: "/strong-healthy/calorie-deficit-calculator",
                    },
                    {
                        title: "Strength for Life",
                        body: "A 12-week beginner strength plan with bodyweight, dumbbell, and resistance band options.",
                        path: "/strong-healthy/strength-for-life",
                    },
                    {
                        title: "4-Week Strength Training for Runners",
                        body: "A runner-focused strength program designed to build power and endurance.",
                        path: "/strong-healthy/strength-training",
                    },
                    {
                        title: "21-Days Mobility Program",
                        body: "Daily mobility work to help improve flexibility, reduce stiffness, and support better movement.",
                        path: "/strong-healthy/mobility",
                    },
                    {
                        title: "101 Body Weight Exercises",
                        body: "A library of bodyweight exercises you can do anywhere.",
                        path: "/strong-healthy/oneHundred",
                    },
                ],
            },
        ],
        whyWatch: "Watch this if you want a simple, practical reminder that exercise is not just about fitness. It is about protecting your future independence, mobility, strength, heart, brain, and ability to keep enjoying life well into your 80s and beyond.",
    },
    {
        id: "april",
        month: "April 2026 Meetup",
        title: "Fat Loss for Health and Longevity",
        videoUrl: "https://vimeo.com/1187728623?share=copy&fl=sv&fe=ci",
        intro: "In this Momentum Meetup, Val talks about fat loss in a practical, health-focused way: not through extreme diets, hacks, or cutting out entire food groups, but by understanding what actually works.",
        focus: "The focus is on building a sustainable approach that supports energy, muscle, independence, and long-term health.",
        sections: [
            {
                title: "Key Insights",
                items: [
                    {
                        title: "Fat loss comes down to a calorie deficit.",
                        body: "Val explains that fat loss happens when your body uses more energy than you take in. Different diets can work, but usually because they help people eat less overall, not because they are magical.",
                    },
                    {
                        title: "You do not need to cut out entire food groups.",
                        body: "Carbs, fats, and foods you enjoy can still fit into a healthy fat loss approach. What matters most is the total amount you eat and whether your plan is something you can actually maintain.",
                    },
                    {
                        title: "Tracking helps you stop guessing.",
                        body: "Val shares that one of the biggest changes for her was honestly tracking food, even for a short period. Measuring portions and seeing the numbers can help you understand where your calories are really coming from.",
                    },
                    {
                        title: "Fat loss and weight loss are not the same thing.",
                        body: "The goal is not just to make the scale go down. Val emphasizes the importance of losing fat while protecting muscle, because muscle supports metabolism, movement, strength, and independence as you age.",
                    },
                    {
                        title: "Consistency matters more than perfection.",
                        body: "The talk explains that results come from doing enough, often enough, for long enough. A plan should fit into real life, including restaurants, travel, family meals, and imperfect days.",
                    },
                ],
            },
            {
                title: "Tools & Programs Mentioned",
                items: [
                    {
                        title: "Calorie Intake Calculator",
                        body: "A membership resource inside the Health Hub that helps you estimate how many calories your body needs each day, so you can better understand what a calorie deficit might look like for you.",
                        path: "/strong-healthy/calorie-deficit-calculator",
                    },
                    {
                        title: "Fat Loss Mini Course",
                        body: "A simple membership course designed to help members understand calorie tracking, calorie deficit, and how to approach fat loss in a more sustainable way.",
                        path: "/strong-healthy/calorie-deficit-calculator",
                    },
                    {
                        title: "Strength Training",
                        body: "Val recommends doing some form of strength training to help maintain or build muscle while losing fat.",
                    },
                    {
                        title: "Protein Tracking",
                        body: "The talk encourages prioritizing protein at meals and calculating how much protein may be appropriate based on your goals, age, and activity level.",
                    },
                ],
            },
        ],
        whyWatch: "Watch this talk if you have tried diets before, felt confused by conflicting advice, or want a more realistic way to think about fat loss. You will come away with a clearer understanding of calorie deficit, protein, muscle, and consistency, and how these pieces support better energy, strength, health, and independence over time.",
    },
    {
        id: "protein-after-40",
        month: "June 2026 Meetup",
        title: "Protein after 40: way more than just muscle",
        videoUrl: "https://vimeo.com/1204507063?share=copy&fl=sv&fe=ci",
        intro: "Watch this Momentum Meetup recording about why protein matters after 40, including how it supports strength, recovery, metabolism, and long-term health.",
        focus: "This session looks at protein as more than a muscle-building nutrient, with practical context for staying strong, active, and resilient as you age.",
        sections: [
            {
                title: "Key Insights",
                items: [
                    {
                        title: "Protein is more than muscle.",
                        body: "Protein is the building block for nearly every tissue in your body, including muscles, skin, hair, nails, organs, hormones, enzymes, and parts of your immune system. Exercise creates the stimulus, and protein provides the building material your body needs to repair and recover.",
                    },
                    {
                        title: "Protein matters more after 40, not less.",
                        body: "As we age, muscles become less sensitive to protein, a phenomenon known as anabolic resistance. Building muscle can become harder, recovery can take longer, and maintaining muscle requires more effort, which is why older adults often need more protein to support muscle protein synthesis.",
                    },
                    {
                        title: "Muscle loss is not just aging.",
                        body: "Physical inactivity, lack of strength training, insufficient protein intake, chronic illness, and excessive sitting all contribute to muscle loss. Healthy adults who strength train and eat enough protein can maintain significantly more muscle than inactive peers.",
                    },
                    {
                        title: "Most people have a breakfast problem.",
                        body: "Many adults eat very little protein at breakfast and try to make up for it at dinner. A better approach is spreading protein more evenly across the day, aiming for roughly 25 to 35 grams at breakfast, lunch, and dinner when appropriate.",
                    },
                    {
                        title: "Your protein target may be higher than the minimum.",
                        body: "The common recommendation of 0.8 grams per kilogram of body weight is the minimum to avoid deficiency. General health, active lifestyles, fat loss, and muscle gain often call for higher ranges, from about 1.0 to 2.2 grams per kilogram depending on the goal.",
                    },
                    {
                        title: "The lean protein rule can make labels easier.",
                        body: "A simple shortcut is to take the grams of protein and add a zero. If a food has 20 grams of protein, compare it to 200 calories. Foods with significantly fewer calories than that are generally very protein-dense options.",
                    },
                    {
                        title: "Convenience can help consistency.",
                        body: "Whole foods should generally be the foundation, but protein milk, protein bars, protein chips, clear protein drinks, and plant-based protein powders can help you consistently hit your daily protein needs.",
                    },
                    {
                        title: "Protein myths can get in the way.",
                        body: "The talk addresses common myths, including that protein damages healthy kidneys, exercise means you do not need extra protein, you are too old to build muscle, and protein only matters right after workouts. Total daily intake and spreading protein through the day matter most.",
                    },
                ],
            },
            {
                title: "This Week's Action Plan",
                items: [
                    {
                        title: "Calculate your protein target.",
                        body: "Use your body weight and activity level to estimate how much protein you should be consuming each day.",
                    },
                    {
                        title: "Upgrade your breakfast.",
                        body: "Aim for 25 to 35 grams of protein at breakfast so you are not trying to catch up with all of your protein later in the day.",
                    },
                    {
                        title: "Include protein at every meal.",
                        body: "Spread protein across breakfast, lunch, dinner, and an optional snack if needed instead of saving most of it for dinner.",
                    },
                ],
            },
            {
                title: "Resources Mentioned",
                items: [
                    {
                        title: "Protein and aging research",
                        body: "Research from Dr. Stuart Phillips on protein requirements and aging, research from Dr. Luc van Loon on muscle protein synthesis and aging, and International Society of Sports Nutrition position stands on protein intake and healthy aging.",
                    },
                    {
                        title: "Protein products discussed",
                        body: "Iron Vegan Protein, protein milk products, David Protein Bars, Barebells Protein Bars, and Quest Protein Chips were mentioned as examples of convenient protein options.",
                    },
                    {
                        title: "High-protein foods by eating style",
                        body: "Examples included chicken, turkey, lean beef, tuna, salmon, Greek yogurt, cottage cheese, eggs, egg whites, tofu, tempeh, edamame, soy milk, lentils, beans, and plant-based protein powders.",
                    },
                ],
            },
        ],
        whyWatch: "If you are over 40 and want to stay active, strong, independent, and capable for years to come, this presentation provides practical, evidence-based guidance you can start applying immediately. The goal is not to become a bodybuilder. The goal is to give your body the resources it needs to support the life you want to live.",
    },
    {
        id: "smart-running-training",
        month: "September 2026 Meetup",
        title: "Smart Running Training",
        videoUrl: "https://vimeo.com/1231393663?share=copy",
        belowVideoLinks: [
            {
                label: "View presentation slides (PDF)",
                href: "/docs/monthly-meetups/smart-running-training-slides.pdf",
            },
            {
                label: "Six-Minute Pace Calculator",
                to: "/training-plans/six-minute-pace-calculator",
            },
        ],
        intro: "In this Momentum Meetup, the speaker shares a practical approach to running built around consistency, smart pacing, and two purposeful workouts each week.",
        focus: "Learn how to use a six-minute time trial to set training zones, balance long runs with speed work and easy supporting runs, and adjust your effort as your fitness and the weather change.",
        sections: [
            {
                title: "Key Insights",
                items: [
                    {
                        title: "Build your week around two key workouts.",
                        body: "Make a long run and a speed session your main training priorities. Keep the other runs easy so they support recovery, help you stay injury-free, and make consistent training possible.",
                    },
                    {
                        title: "Use pace as your guide, and read heart rate in context.",
                        body: "Heat, cold, sleep, fatigue, and sensor accuracy can all affect heart-rate readings. Pace gives you a practical way to set training targets, while heart rate can still help you notice how hard a run feels under the conditions of the day.",
                    },
                    {
                        title: "Recalibrate your training zones with a six-minute test.",
                        body: "Run as far as you can at a steady hard effort for six minutes, then use the average pace to calculate your zones and race estimates. Repeat the test every four to six weeks, or when your fitness or the weather changes substantially.",
                    },
                    {
                        title: "Keep supporting runs genuinely easy.",
                        body: "Zone 1 runs should feel conversational and relaxed. Their role is to support recovery and build consistency between the workouts that carry the main training stimulus.",
                    },
                    {
                        title: "Give long runs and speed sessions distinct jobs.",
                        body: "The talk recommends Zone 2 for long runs of at least 45 minutes, with a two-and-a-half-hour cap. For speed work, it describes short Zone 5 intervals and cautions against spending too much time in the moderate Zone 3 and 4 range.",
                    },
                    {
                        title: "Avoid running too hard or too slowly for the workout's purpose.",
                        body: "Easy days that become hard can compromise recovery, while workouts that never reach their intended effort may miss the adaptation they were designed for. Consistent pacing helps each session serve its role.",
                    },
                ],
            },
            {
                title: "Training Framework",
                items: [
                    {
                        title: "Long run: Zone 2.",
                        body: "Run for at least 45 minutes, adjusting pace within your Zone 2 range based on how rested you feel. Keep the run under two hours and 30 minutes; scale the duration to your event and experience.",
                    },
                    {
                        title: "Speed session: Zone 5 intervals.",
                        body: "After a 10 to 15 minute warm-up, run 30 seconds fast and recover for 30 seconds, repeating 8 to 15 times. Start with fewer repetitions, build gradually, and take a break from this speed-work format after about eight weeks.",
                    },
                    {
                        title: "Supporting runs: Zone 1.",
                        body: "Use a relaxed conversational pace on the other days. These runs should leave you fresher for the long run and speed session, rather than adding another hard effort.",
                    },
                ],
            },
            {
                title: "Resource Mentioned",
                items: [
                    {
                        title: "Six-Minute Pace Calculator",
                        body: "Enter your six-minute test pace to see suggested training zones and race estimates.",
                        path: "/training-plans/six-minute-pace-calculator",
                    },
                ],
            },
        ],
        whyWatch: "Whether you're building toward a race or running to stay healthy, this meetup offers a clear way to structure your week, choose a useful training pace, and make progress through consistency rather than trying to make every run hard.",
    },
];

export default monthlyMeetupsData;
